module.exports = __webpack_public_path__ + "img/mind_template_item_2_3.5b44cc0e.png";